<template>
    <!--
    Maps svg icon according to given name.

    @property {String} name
    @property {String} viewBox
    -->
    <svg :class="'icon ico-' + name" :viewBox="viewBox || '0 0 100 100'">
        <title v-if="titleTag">{{ titleTag }}</title>
        <use :xlink:href="reference"></use>
    </svg>
</template>

<script>
/**
 *  Inject svg from sprite, based on name (svg-filename)
 */
export default
{
    name: 'Icon',

    props: {
        'name': { type: String, required: true },
        'viewBox': { type: String },
        'titleTag': { type: String },
    },

    computed:
    {
        reference()
        {
            return '#' + this.name;
        },
    },
}
</script>



// WEBPACK FOOTER //
// Icon.vue?0e9c96df